import type { TFunction } from "i18next";

/**
 * ROUND 15 H9, eighth round -- "Graded by user id: Noura Al-Rashid".
 *
 * A sealed row's field names are the chain contract's, and the value
 * beside `graded_by_user_id` is resolved to a person's name before it
 * is printed. The label was the field name with its underscores
 * removed, so it named the id the value no longer was. A `_user_id`
 * field is a person: its label is what they did.
 */
export function chainFieldLabel(field: string): string {
  const base = field.endsWith("_user_id") ? field.slice(0, -"_user_id".length) : field;
  const words = base.replace(/_/g, " ").trim();
  return words.charAt(0).toUpperCase() + words.slice(1);
}

/**
 * ROUND 15 H8 -- a record card's field, said as a reader would say it.
 *
 * The card printed "biz crit" and "rto hours": the column names with
 * their underscores removed. A catalogued label where there is one,
 * else the column name made readable, which is no worse than before.
 */
export function recordFieldLabel(t: TFunction, field: string): string {
  const key = `examiner.field.${field}`;
  const said = t(key, { defaultValue: "" });
  return said && said !== key ? said : chainFieldLabel(field);
}
